export default __webpack_public_path__ + "static/media/svg-3.650d098b.svg";